import { render, staticRenderFns } from "./HistorialPrestacional.vue?vue&type=template&id=997b5f5c&scoped=true&lang=pug"
import script from "./HistorialPrestacional.vue?vue&type=script&lang=js"
export * from "./HistorialPrestacional.vue?vue&type=script&lang=js"
import style0 from "./HistorialPrestacional.vue?vue&type=style&index=0&id=997b5f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997b5f5c",
  null
  
)

export default component.exports